import { makeStyles } from "tss-react/mui-compat"

const useHeadingStyles = makeStyles()(
  (_theme) => ({
    h1: {
      fontFamily: "Lato, sans-serif !important",
      fontSize: "36px !important",
      lineHeight: "42px !important",
      color: "#556064 !important",
      fontWeight: "400 !important" as any,
    },
    h1alt: {
      fontFamily: "Raleway",
      fontSize: "36px",
      lineHeight: "42px",
      fontWeight: 500,
      color: "white",
    },
    h2: {
      fontSize: "28px",
      lineHeight: "42px",
      fontFamily: "Raleway",
      fontWeight: 500,
    },
    h3: {
      fontFamily: "Lato, sans-serif",
      fontSize: "24px",
      lineHeight: "29px",
      color: "#556064",
      fontWeight: 400,
    },
    h4: {
      fontFamily: "Lato, sans-serif",
      fontSize: "24px",
      lineHeight: "29px",
      color: "#556064",
      fontWeight: 400,
    },
    h5: {
      fontFamily: "Lato",
      fontSize: "20px",
      lineHeight: "24px",
      color: "#262B2D",
      fontWeight: 400,
      letterSpacing: 0,
    },
    newh1: {
      color: "#262B2D",
      fontFamily: "Lato",
      fontSize: "36px",
      letterSpacing: 0,
      lineHeight: "44px",
      fontWeight: 400,
    },
    microh3: {
      fontFamily: "Raleway",
      fontStyle: "normal",
      fontWeight: 600,
      fontSize: "24px",
      lineHeight: "28px",
      color: "#000000",
    },
  })
)

export default useHeadingStyles
